// @ts-nocheck
/* eslint-disable func-names */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/named */
import { takeLatest, spawn, put, select } from 'redux-saga/effects';

import apiRequest, { apiSuccess, objectToQueryString } from 'utils/api';
import { truthty } from 'utils/functions';
import { appActions, PRINT_RECEPTION_LABEL } from 'commons/reducer';
import { sendAlert } from 'utils/alertUtils';
import { PROCESSES } from '../reducer';
import { checkAutomation } from 'utils/hooks/useAutomationPermission';
import { parsedObjects } from 'utils/reduxActions';

function _enrichProcessesWithAutomation(response, globalObjects) {
  if (!response || typeof response.count !== 'number' || !response.objects) {
    return {
      processesIds: [],
      suppliersByProcess: {},
      count: 0,
      objects: globalObjects,
    };
  }

  const processes = response.objects?.processes || {};
  const processesIds = Object.keys(processes).map(Number);

  return {
    processesIds,
    suppliersByProcess: {},
    count: response.count,
    objects: {
      ...globalObjects, // Todo lo global (accounts, roles, etc.)
      processes: response.objects.processes, // Solo procesos del backend
      lots: response.objects.lots,
      products: response.objects.products,
      varieties: response.objects.varieties,
      suppliers: response.objects.suppliers,
      entities: response.objects.entities,
      receiptLots: response.objects.receiptLots,
      lotReceiptLots: response.objects.lotReceiptLots,
      processTransitions: response.objects.processTransitions,
      processTypes: response.objects.processTypes,
      workShiftTypes: response.objects.workShiftTypes,
    },
  };
}

function* getStateFromApi() {
  yield takeLatest([PROCESSES.GET_STATE_FROM_API, PROCESSES.CHANGE_PAGINATION], function* (action) {
    try {
      yield put(appActions.setLoader('get-process', true));

      const permissions = yield select((state) => state.app?.permissions || []);
      const isAutomation = checkAutomation(permissions);
      const path = isAutomation ? 'api/v1/processes/automation' : 'api/v1/processes';

      const response = yield apiRequest(
        `${path}?${objectToQueryString({
          page: action.pagination.page,
          rowsPerPage: action.pagination.rowsPerPage,
          ...action.filters,
        })}`,
        { method: 'get' },
      );

      const globalObjects = yield select((state) => state.app?.objects || {});
      let enrichedResponse;

      if (isAutomation) {
        enrichedResponse = _enrichProcessesWithAutomation(response, globalObjects);
        // NO usar parsedObjects para automatización - los datos ya vienen listos
      } else {
        enrichedResponse = response;
      }

      yield put(apiSuccess(PROCESSES.GET_STATE_FROM_API_SUCCESS, enrichedResponse));
    } catch (error) {
      console.error('Error en saga procesos:', error);
      yield put(appActions.setError('Error al procesar la lista de procesos'));
    } finally {
      yield put(appActions.setLoader('get-process', false));
    }
  });
}

function* createProcess() {
  yield takeLatest(PROCESSES.CREATE_PROCESS, function* (action) {
    yield put(appActions.setLoader('create-edit-process', true));
    const response = yield apiRequest('api/v1/processes', {
      method: 'post',
      body: JSON.stringify(action.controls),
    });
    if (truthty(response.error)) {
      yield put(appActions.setError(response.errorMsg));
    } else {
      yield put(apiSuccess(PROCESSES.CREATE_PROCESS_SUCCESS, response));
    }
    yield put(appActions.setLoader('create-edit-process', false));
  });
}

function* editProcess() {
  yield takeLatest(PROCESSES.EDIT_PROCESS, function* (action) {
    yield put(appActions.setLoader('create-edit-process', true));
    const response = yield apiRequest(`api/v1/processes/${action.id}`, {
      method: 'put',
      body: JSON.stringify(action.controls),
    });
    if (truthty(response.error)) {
      yield put(appActions.setError(response.errorMsg));
    } else {
      yield put(apiSuccess(PROCESSES.EDIT_PROCESS_SUCCESS, response));
      sendAlert({
        type: 'item_edit_process',
        processId: action.id,
        title: `Proceso ${action.id} Editado`,
        description: `${response.meta.summary} `,
        itemType: response.meta.summary,
        inputWeight: null,
        outputWeight: null,
      });
    }
    yield put(appActions.setLoader('create-edit-process', false));
  });
}

function* deleteProcess() {
  yield takeLatest(PROCESSES.DELETE_PROCESS, function* (action) {
    yield put(appActions.setLoader('delete-process', true));
    const response = yield apiRequest(`api/v1/processes/${action.id}`, { method: 'delete' });
    if (response.error) {
      yield put(appActions.setError(response.errorMsg));
    } else {
      yield put(
        apiSuccess(PROCESSES.DELETE_PROCESS_SUCCESS, {
          item: response.deletedProcess,
          type: 'processes',
        }),
      );
      sendAlert({
        type: 'item_deletion',
        processId: action.id,
        title: `Proceso ${action.id} Eliminado`,
        description: `El proceso ${action.id} ha sido eliminado`,
        itemType: response.meta,
        inputWeight: null,
        outputWeight: null,
      });
    }
    yield put(appActions.setLoader('delete-process', false));
  });
}

function* submitEmployeeCosts() {
  yield takeLatest(PROCESSES.SUBMIT_EMPLOYEE_COSTS, function* (action) {
    yield put(appActions.setLoader('submit-employee-costs', true));
    const data = new FormData();
    data.append('files', action.file, action.file.name);
    action.processesIds.forEach((id) => data.append('processesIds[]', id));
    const response = yield apiRequest('api/v1/processes/addEmployeeCosts', {
      method: 'post',
      body: data,
      headers: {
        Accept: 'application/json',
      },
    });
    if (truthty(response.error)) {
      yield put({ type: PROCESSES.SUBMIT_EMPLOYEE_COSTS_FAIL });
      yield put(appActions.setError(response.errorMsg));
    } else {
      yield put(apiSuccess(PROCESSES.SUBMIT_EMPLOYEE_COSTS_SUCCESS, response));
    }
    yield put(appActions.setLoader('submit-employee-costs', false));
  });
}

function* getAllReceiptLots() {
  yield takeLatest(PROCESSES.GET_ALL_RECEIPT_LOTS, function* () {
    const response = yield apiRequest('api/v1/receipts/allReceiptLots', { method: 'get' });
    yield put(apiSuccess(PROCESSES.GET_ALL_RECEIPT_LOTS_SUCCESS, response));
  });
}

// function* executeAutomaticTransition() {
//   yield takeLatest(PROCESSES.EXECUTE_AUTOMATIC_TRANSITION, function* (action) {
//     try {
//       yield put(appActions.setLoader('execute-automatic-transition', true));
//       const response = yield apiRequest('api/v1/processes/scan-transition', {
//         method: 'post',
//         body: JSON.stringify(action.data),
//       });

//       if (response.error) {
//         yield put(appActions.setError(response.errorMsg));
//       } else {
//         yield put({ type: PROCESSES.EXECUTE_AUTOMATIC_TRANSITION_SUCCESS, payload: response });
//         if (action.callback) action.callback(null, response);
//       }
//     } catch (error) {
//       yield put(appActions.setError("Error en la transición automática"));
//       if (action.callback) action.callback(error);
//     } finally {
//       yield put(appActions.setLoader('execute-automatic-transition', false));
//     }
//   });
// }

/* En Processes/saga/index.js */

const safeStringify = (obj) => {
  try {
    return JSON.stringify(obj);
  } catch {
    return '[no serializable]';
  }
};

function* executeAutomaticTransition() {
  yield takeLatest(PROCESSES.EXECUTE_AUTOMATIC_TRANSITION, function* (action) {
    try {
      yield put(appActions.setLoader('execute-automatic-transition', true));

      const response = yield apiRequest('api/v1/processes/scan-transition', {
        method: 'post',
        body: JSON.stringify(action.data),
      });

      if (response?.zpl) {
        yield put({
          type: PRINT_RECEPTION_LABEL,
          device: action.device,
          allowPdfFallback: true,
          zpl: response.zpl,
        });
      }

      yield put({ type: PROCESSES.EXECUTE_AUTOMATIC_TRANSITION_SUCCESS, payload: response });

      if (typeof action.callback === 'function') {
        try {
          action.callback(null, response);
        } catch (cbErr) {
          alert(`D-ERROR callback: ${cbErr?.message || 'sin mensaje'}`);
        }
      }
    } catch (error) {
      alert(
        'CATCH\n' +
          `msg: ${error?.message || 'sin mensaje'}\n` +
          `status: ${error?.status || error?.response?.status || 'N/A'}\n` +
          `body: ${safeStringify(error?.response?.data || error?.response || null)}`,
      );

      const responseData = error?.response?.data || error?.response || null;
      if (responseData?.status === 'WAITING_SUBDIVISION') {
        yield put({ type: PROCESSES.EXECUTE_AUTOMATIC_TRANSITION_SUCCESS, payload: responseData });
      } else {
        yield put(appActions.setError('Error en la transición automática'));
      }

      if (typeof action.callback === 'function') {
        try {
          action.callback(error);
        } catch (_) {}
      }
    } finally {
      yield put(appActions.setLoader('execute-automatic-transition', false));
    }
  });
}

function* reclassifySpeciesDispatch() {
  yield takeLatest(PROCESSES.RECLASSIFY_SPECIES_DISPATCH, function* (action) {
    try {
      yield put(appActions.setLoader('reclassify-species-dispatch', true));

      const response = yield apiRequest(
        `api/v1/receipts/${action.receiptId}/reclassify-species-dispatch`,
        {
          method: 'post',
          body: JSON.stringify(action.controls),
        },
      );

      if (response.error) {
        yield put(appActions.setError(response.errorMsg));
        if (typeof action.callback === 'function') {
          action.callback(response.errorMsg);
        }
        return;
      }

      yield put({
        type: PROCESSES.RECLASSIFY_SPECIES_DISPATCH_SUCCESS,
        payload: response,
      });
      yield put(appActions.setSuccess('process.reclassification.success'));

      if (typeof action.callback === 'function') {
        action.callback(null, response);
      }
    } catch (error) {
      yield put(appActions.setError(error?.message || 'process.reclassification.error'));
      if (typeof action.callback === 'function') {
        action.callback(error);
      }
    } finally {
      yield put(appActions.setLoader('reclassify-species-dispatch', false));
    }
  });
}

export default function* saga() {
  yield spawn(submitEmployeeCosts);
  yield spawn(getStateFromApi);
  yield spawn(deleteProcess);
  yield spawn(createProcess);
  yield spawn(editProcess);
  yield spawn(getAllReceiptLots);
  yield spawn(executeAutomaticTransition);
  yield spawn(reclassifySpeciesDispatch);
}
